module.exports = __webpack_public_path__ + "img/give_up.c8c1c287.png";